import type { Color } from 'src/types/theme';

export const violet: Color = {
  50: '#F2F8FF',
  100: '#D2E4F9',
  200: '#C9D3EC',
  300: '#89B9F0',
  400: '#65A4EC',
  500: '#4E6FC1',
  600: '#1A71D5',
  700: '#1457A3',
  800: '#1A284B',
  900: '#082240',
};
